exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Resizer{background:#000;opacity:.2;z-index:1;box-sizing:border-box;background-clip:padding-box}.Resizer:hover{-webkit-transition:all 2s ease;transition:all 2s ease}.Resizer.horizontal{height:11px;margin:-5px 0;border-top:5px solid hsla(0,0%,100%,0);border-bottom:5px solid hsla(0,0%,100%,0);cursor:row-resize;width:100%}.Resizer.horizontal:hover{border-top:5px solid rgba(0,0,0,.5);border-bottom:5px solid rgba(0,0,0,.5)}.Resizer.vertical{width:11px;margin:0 -5px;border-left:5px solid hsla(0,0%,100%,0);border-right:5px solid hsla(0,0%,100%,0);cursor:col-resize;height:100%}.Resizer.vertical:hover{border-left:5px solid rgba(0,0,0,.5);border-right:5px solid rgba(0,0,0,.5)}.Pane.vertical,.Pane.vertical>div{height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/app/components/Posts/splitPane.less
 ** module id = 520
 ** module chunks = 0
 **/